<template>
  <div id="mapTop" ></div>
</template>

<script>
import {
  isBuy,
  toBuy,
  uid,
  merchantId,
  openid,
  token,
  imgHost,
  baseImgHost,
  play_id,
  prodImg
} from "@/api/api";
import imgurl from "@/static/imgs/navTour.png";
import {
  infoPlayEnglishMap,
  payDialogEnglishMap,
  messageEnglishMap,
  templateContent,
  templateContent2,
  myInfoWindow,
  addressMasker,
  ClusterBubble,
  lineTourInfo
} from "@/static/const.js";
// import imgurl from "../static/imgs/navTour.png";
import { compatibleAndroid } from "@/utils/util.js";
import eventBus from "@/utils/eventBus";
import $ from "jquery";
export default {
  props: {
    mylat: {
      type: Number,
      default: null,
    },
    lat: {
      type: Number,
      default: null,
    },
    lon: {
      type: Number,
      default: null,
    },
    mylng: {
      type: Number,
      default: null,
    },

    mylocationname: {
      type: String,
      default: "",
    },

    addressInfo: {
      type: Object,
      default: () => {},
    },
    isBuy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      map: "", // 当前地图
      marker: {}, // 地图起点终点

      // 地图图片对象
      earthlayer: "",
      // 数据集合,记录所有的景点信息
      markerList: [],

      // 点聚合标识
      markerCluster: "",
      dom: "",
      // 文本标记集合
      labelMapList: [],
      // 信息弹窗
      infoWindowMap: [],
      // 记录每次点击弹窗的次数, 奇数为要暂停, 偶数为开始播放或继续播放
      count: 0,
      // 路线
      polylineArr: [],
      dashPolylineArr: [],
      // 景点点标记map集合
      markerggregate: "",
      // 播放中的marker
      audioMarker: null,
      // 点击播放时的播放的当前marker的id
      removeId: "",
      // 点击播放时的播放的当前marker的索引
      removeIndex: "",
      // 信息框开启状态
      isInfoClose: true,
      // 点击详情查看详情弹窗的当前marker索引项
      showInfoIndex: null,
      // 数据集合, 路线,服务中心等
      contentData: [],
      // 路线
      inlet_and_outlet: [],
      // 服务中心marker集合
      serverMarkerList: [],
      // 服务中心lalbel集合
      serverLabelList: [],
      // 当前tab点击索引
      activeIndex: 0,
      zoom: null,
      geometries: [],
      isMove: false,
      mapHeight: "",
      //路线marker点
      lineTourMarkerList:[],
      //服务中心信息弹窗
      infoServerMap: null,
      // 服务中心marker
      addressMarker: null,
      // 自动播放状态时,上次播放时的marker的id
      automaticId: null,
      isShowPrizeCount: 0,
      spointx: 0,
      spointy: 0,
      // 聚合簇数组
      clusterBubbleList: [],
      zoom: 0,
      CircleLine: null,
      CircleRadiusArr: [],
      LanLngArr: [],
      // 是否切换英文
      isEnglish: false,
      windowInfoIndex: null,
      infoServerData: {},
      // 记录用户点击过的路线, 切换tarber时,优先展示此路线
      lineActiveIndex: 0,
      lineMarkerList: [],
      serverClassName: null,
      choseMarker: "",
      second_service: [],
      second_service_category: [],
      timer:null,
      lineMaker:[]
    };
  },
  watch: {
    lat() {
      this.spointx = this.$props.lat;
      this.spointy = this.$props.lon;
      // this.addressMarker=null

      this.addressMarker.setPosition(
        new TMap.LatLng(this.spointx, this.spointy)
      );
    },
    // markerList(newVal,oldVal){
    //   console.log(newVal,oldVal)

    // },
    // activeIndex(newVal,oldVal){
    //     // console.log(newVal,oldVal)
    //     if(newVal===-1){
    //       console.log(this.contentData)
    //       this.markerList=this.contentData.second_service
    //       this.initMaskerCluster();

    //     }
    // }
  },

  created() {
    let that = this;

    // 监听tabbar切换事件
    this.initEventBus();
    // 初始化自定义点聚合
    this.initClusterBubbleProto();
    // 初始化自定义景点名称标签
    this.initMyInfoWindowProto();
    // 初始化自定义当前位置标签
    this.initAddressProto();
  },
  mounted() {
    let that = this;
    let mapTop = document.getElementById("mapTop");
    let height = document.documentElement.clientHeight;
    // mapTop.style.height = parseInt(height) - 52 + "px";
    window.onresize = () => {
      let height = document.documentElement.clientHeight;
      // mapTop.style.height = parseInt(height) - 52 + "px";
    };

    mapTop.style.fontSize = 16 + "px";


    this.setMap();
    this.hideLogo();
  },
  methods: {
    initEventBus() {
      this.initBusChangeShowInfo();
      // 点击tarber切换展示或隐藏路线
      this.initBussetLineVis();
      // 点击tarber音乐关闭按钮
      this.initBusstopItem();
      // 底部tab点击任意一项服务中心站点时触发
      this.initBusshowServerMap();
      // 音乐状态切换marker状态切换事件
      this.initBuschangeMarker();
      // audio组件音乐暂停重新播放时触发
      this.initBusrepletePlay();
      // tarber切换控制地图各个控件显示隐藏
      this.initBusremove();
      // 底部tab点击任意一项景点时触发
      this.initBusshowInfoWindow();
      // 底部tarber点击播放音乐时触发
      this.initBusplayItem();
      // 底部切换服务设施分类触发
      this.initchangeSeverMaker();
    },
    initchangeSeverMaker() {
      eventBus.on("changeSeverMaker", (data) => {
        // console.log(data);
        this.serverClassName = data.name;
        this.changeServerVisible();
      });
    },
    changeServerVisible() {
      let arr = [];
      let arr1 = [];

      if (this.serverClassName && this.serverClassName !== "全部") {
        this.inlet_and_outlet.forEach((item, index) => {
          // console.log(item)
          if (item.className === this.serverClassName) {
            arr.push(index);
          }
        });
        this.serverMarkerList.forEach((item, index) => {

          let findItem = arr.find((item) => item === index);

          if (findItem != undefined) {
            item.setVisible(true);
            this.serverLabelList[index].setVisible(true);
          } else {
            item.setVisible(false);
            this.serverLabelList[index].setVisible(false);
          }
        });
        return;
      }
      if (
        this.serverClassName &&
        this.serverClassName == this.second_service_category[0].name
      ) {
        this.second_service.forEach((item, index) => {
          if (item.className === this.serverClassName) {
            arr1.push(index);
          }
        });
        this.serverMarkerList.forEach((item, index) => {
          let findItem = arr1.find((item) => item === index);
          if (findItem != undefined) {
            item.setVisible(true);
            this.serverLabelList[index].setVisible(true);
          } else {
            item.setVisible(false);
            this.serverLabelList[index].setVisible(false);
          }
        });
        return;
      }
      this.serverMarkerList.forEach((item, index) => {
        item.setVisible(true);
        this.serverLabelList[index].setVisible(true);
      });

      // console.log(this.serverMarkerList,this.serverLabelList,222222222)
    },
    initBusplayItem() {
      let that = this;
      eventBus.on("playItem", (message) => {
        that.count = 0;
        that.infoWindowMap.close();
        if (that.removeId) {
          that.addMarkerCluster(that.markerList[that.removeIndex]);
          that.closeSrc(true);
        }
        let x = message.coordinate.split(",")[1];
        let y = message.coordinate.split(",")[0];
        that.map.setCenter(new TMap.LatLng(x, y));
        that.removeId = message.id;
        that.removeIndex = that.markerList.findIndex((item) => {
          return message.id === item.id;
        });
        if (that.$parent.isOpenAudio) {
          eventBus.emit(
            "showMessage",
            `${
              that.isEnglish
                ? messageEnglishMap[0].english
                : messageEnglishMap[0].chinese
            }`
          );
          that.removeId = "";
          that.removeIndex = "";
          return;
        }
        // 如果该歌曲为付费歌曲, 开启支付弹窗并返回重置数据
        if (!that.isBuy && Number(message.type) === 1) {
          that.showPrizeDialog(that.removeIndex);
          that.removeIndex = null;
          that.removeId = null;
          // his.automaticId = null
          that.isShowPrizeCount = 1;
          return;
        }
        // 删除聚合中该id的marker
        that.markerCluster.remove(that.removeId);
        // 展示播放中的marker
        that.audioMarker.setVisible(true);
        // 开启音乐
        that.changeSrc(that.removeIndex);
        // 播放状态标识+1
        that.count++;

        // 更新播放中marker至当前播放位置
        that.updateAudioMarker(message);
      });
    },
    initBusshowInfoWindow() {
      eventBus.on("showInfoWindow", (message) => {
        this.changeInfoWindowVisbel(message);
      });
    },
    initBusChangeShowInfo() {
      // 信息框查看详情切换事件
      eventBus.on("changeShowInfo", (message) => {
        // 一些操作，message就是从top组件传过来的值
        this.showInfoIndex = null;
      });
    },
    //
    initBussetLineVis() {
      eventBus.on("setLineVis", (message,data) => {
      //  console.log(message)


        this.setLineVisibel(message);
        this.lineActiveIndex = message;
      });
    },
    initBusrepletePlay() {
      let that = this;
      eventBus.on("repletePlay", (message) => {
        if (!this.removeId) {
          this.removeId = message.id;
          this.removeIndex = this.markerList.findIndex((item) => {
            return item.id === message.id;
          });
          // 删除聚合中该id的marker
          this.markerCluster.remove(this.removeId);
          // 展示播放中的marker
          this.audioMarker.setVisible(true);
          // 播放状态标识+1
          this.count++;
          // 更新播放中marker至当前播放位置
          this.updateAudioMarker(this.markerList[this.removeIndex]);
        }
        eventBus.emit("playIcon", "playing");
      });
    },

    initBusremove() {
      let that = this;
      eventBus.on("remove", (message) => {
        this.activeIndex = message;


        this.lineTourMarkerList.forEach((item) => {
          item.setMap(null)
      });
       this.lineTourMarkerList=[]

        // console.log(this.activeIndex)
        // 一些操作，message就是从top组件传过来的值


        if ( message=== 0) {
          this.changeTarberSeince();
          return
        }

        if ( message>= 2) {
          // this.lineTourMarkerList.forEach((item) => {
          //   item.setVisible(false);
          // });
          this.changeTarberServer();
           return
        }

        // if()
        if ( message== -1) {
          // this.lineTourMarkerList.forEach((item) => {
          //   item.setVisible(false);
          // });
          this.changeTarberServer();
           return
        }
      });

       eventBus.on("lineTour",(data)=>{
        if(this.lineTourMarkerList){
           this.lineTourMarkerList.forEach((item) => {
          item.setMap(null)
      });
       this.lineTourMarkerList=[]
        }
              this.changeTarberLine(data);
              this.lineMaker=data

              return

       })


    },
    initBuschangeMarker() {
      let that = this;
      eventBus.on("changeMarker", (message) => {
        if (this.removeId && message === "pause") {
          this.addMarkerCluster(this.markerList[this.removeIndex]);
          that.audioMarker.setVisible(false);
          this.infoWindowMap.close();
        } else if (this.removeId && message === "play") {
          this.markerCluster.remove(this.removeId);
          // 展示播放中的marker
          this.audioMarker.setVisible(true);
          // 更新播放中marker至当前播放位置
          this.updateAudioMarker(this.markerList[this.removeIndex]);
        }
      });
    },
    initBusstopItem() {
      let that = this;
      eventBus.on("stopItem", (message) => {
        that.addMarkerCluster(message);
        this.count = 0;
        this.infoWindowMap.close();
        this.closeSrc(true);
      });
    },
    initBusshowServerMap() {
      let that = this;
      eventBus.on("showServerMap", (message) => {
        let coordinate = message.longitude;

        let center = new TMap.LatLng(
          coordinate.split(",")[1],
          coordinate.split(",")[0]
        );

        this.map.setCenter(center);
        this.infoServerMap.open();
        // 设置信息窗位置
        this.infoServerMap.setPosition(center);
        let data = message;
        this.infoServerData = data;
        let eword = data.text;
        let epointx = coordinate.split(",")[1];
        let epointy = coordinate.split(",")[0];

        let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${that.spointx}&spointy=${that.spointy}&epointx=${epointx}&epointy=${epointy}&eword=${eword}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;
        that.infoServerMap.setContent(
          `<div style="padding:  0 13px; font-size: 13px" ><a  id='infomation'  style='display: inline-block; width: 18px; height: 40px; line-height: 40px'><img src="${baseImgHost}/ditu/daohang.png" style="width: 18px; height: 18px"></a><p style="display: inline-block; margin-left: 16px;  line-height: 40px;    vertical-align: top;"><span id='serverName'>
         <span id="tabDaolan"> ${
           that.isEnglish ? data.name_eng : data.name
         }</span></p></div>`
        );
        var ua = navigator.userAgent.toLowerCase();


        $("#tabDaolan").on("click", () => {
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            if (data.link_spot) {


              window.open(data.link_spot);
            } else {


              this.$wx.openLocation({
                latitude: parseFloat(epointx),
                longitude: parseFloat(epointy),
                scale: 18,
                success: function (res) {

                },
                fail: function (err) {

                },
              });


            }
        }else{
          window.open(data.link_spot);
        }

        });

        $("#infomation").on("click", () => {
           if (ua.match(/MicroMessenger/i) == "micromessenger") {
              // alert("123456789")
              this.$wx.openLocation({
                latitude: parseFloat(epointx),
                longitude: parseFloat(epointy),
                scale: 18,
                success: function (res) {
                  // alert(JSON.stringify(res))
                },
                fail: function (err) {
                // alert(JSON.stringify(err))
                },
              });

        }else{
            window.location.href = herf;
        }

        });
        // this.map.setZoom(19.5);
      });
    },

    changeTarberSeince() {
      let that = this;
      let clusters = that.markerCluster.getClusters();
      // console.log(that.markerCluster);
      let idList = [];
      clusters.forEach((item) => {
        if (item.geometries.length > 1) {
          item.geometries.forEach((ite) => {
            idList.push(ite.id);
          });
        }
      });
      this.markerggregate.setVisible(true);
      this.setLineVisibel();
      this.serverMarkerList.forEach((item) => {
        item.setVisible(false);
      });
      this.serverLabelList.forEach((item) => {
        item.setVisible(false);
      });
      this.markerggregate.setVisible(true);
      this.labelMapList.forEach((item) => {
        let findItem = idList.find((ite) => {
          return ite === item.id;
        });
        if (!findItem) {
          item.updateDOM();
          item.setVisible(true);
        }
      });
      window.ClusterBubble.prototype.setVisible(true);
      this.audioMarker.setVisible(true);
      if (this.removeId) {
        this.infoWindowMap.open();
      }

      this.infoServerMap.close();
    },
    changeTarberLine(linetour) {

      //路线点击设置marker点
      let that=this

      this.markerggregate.setVisible(false);
      this.labelMapList.forEach((item) => {
        item.setVisible(false);
      });





        this.setLineVisibel(this.lineActiveIndex);
      this.serverMarkerList.forEach((item) => {
        item.setVisible(false);
      });
      this.serverLabelList.forEach((item) => {
        item.setVisible(false);
      });
      this.infoWindowMap.close();
      this.infoServerMap.close();

        //  console.log( this.lineTourMarkerList)
          linetour.forEach((item, index) => {
          this.lineTourMarkerList[index] = new TMap.MultiMarker({
            id: item.id, // 图层id

            map: this.map,
            visible:true,
            styles: {
              // 点标注的相关样式
              'label': new TMap.MarkerStyle({
                      width: 35, // 宽度
                    height: 35, // 高度
                      'color': '#ffffff', //颜色属性
                      'size': 18, //文字大小属性
                      'offset': { x: 0, y: 0 }, //文字偏移属性单位为像素
                      'angle': 0, //文字旋转属性
                      'alignment': 'center', //文字水平对齐属性
                      'verticalAlignment': 'middle', //文字垂直对齐属性
                      src: require("@/static/imgs/circle.png"),
                  })
            },
              geometries: [
                {
                  // 点标注数据数组
                  id: "label",
                  styleId: "label",
                  position: new TMap.LatLng(
                    item.coordinate.split(",")[1],
                    item.coordinate.split(",")[0]
                  ),
                  content:String(index+1), //标注文本

                },
              ],
            });
              // this.timer=setInterval(()=>{
                //  this.lineTourMarkerList[index].setVisible(true)
              // },1000)

            this.lineTourMarkerList[index].on("click", function (evt, i) {
             // 打开信息窗
            that.infoWindowMap.open(); // 打开信息窗
            // 更新位置
            that.infoWindowMap.setPosition(evt.geometry.position); // 设置信息窗位置
            // 设置信息窗内容
            // that.infoWindowMap.setContent(templateContent2);
            linetour.forEach((v, i) => {
              // console.log(Number(v.coordinate.split(",")[0]),Number(v.coordinate.split(",")[1]),evt.geometry.position.lat,evt.geometry.position.lng)
              //根据当前点击marker的经纬度判断 是否在当前的数组中存在然后在设置信息框内容
              if (
                Number(v.coordinate.split(",")[0]) ==
                  evt.geometry.position.lng.toFixed(6) &&
                Number(v.coordinate.split(",")[1]) == evt.geometry.position.lat
              ) {
                if (v.link_spot) {
                  that.infoWindowMap.setContent(templateContent);
                } else {
                  that.infoWindowMap.setContent(templateContent2);
                }
              }
            });

            let lat = evt.geometry.position.lat;
            let lng = evt.geometry.position.lng;

            let tourInfo = document.getElementById("tour");

            let info = document.getElementById("info");
           let audioInfo = document.getElementById("audioInfo");
            that.changeInfoWindowDomText(linetour, lat, lng);

            that.changeWindowDomText(that.isEnglish);
            let tourDaolanMap = document.getElementById("tourDaolan")

          console.log(evt)
            //景点点击弹出的模态框直接跳转地图
             var ua = navigator.userAgent.toLowerCase();


          let eword=that.choseMarker.name

            //  alert(123456798);

            if(tourDaolanMap){
              tourDaolanMap.onclick=()=>{
                console.log(123456789)
                 let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${that.spointx}&spointy=${that.spointy}&epointx=${lat}&epointy=${lng}&eword=${eword?eword:""}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;

                 if (ua.match(/MicroMessenger/i) != "micromessenger") {
                    window.open(herf)
                 }else{
                   that.$wx.openLocation({
                      latitude: parseFloat(that.choseMarker.coordinate.split(",")[1]),
                      longitude: parseFloat(that.choseMarker.coordinate.split(",")[0]),
                      scale: 18,
                      success: function (res) {
                        // alert(JSON.stringify(res))
                      },
                      fail: function (err) {
                        // alert(JSON.stringify(err))
                      },
                    });
                 }
              }
            }

            // 跳转景区
            if (tourInfo) {
              tourInfo.onclick = () => {
                // console.log(that.choseMarker.link_spot)
                window.open(that.choseMarker.link_spot);
              };
            }

            // 展示详情窗口
            if(info){
              info.onclick = () => {
              let lat = evt.geometry.position.lat;
              let lng = evt.geometry.position.lng;
              console.log(linetour,lat,lng)
              that.infoWindowEvent(linetour, lat, lng);
            };
            }

            //播放按钮点击
            audioInfo.onclick = () => {
              that.$emit("audioOpen",true)
              if (that.count % 2 === 0) {
                // 如果信息框切换并且有播放的那个id,说明上个歌曲还在播放状态,需要在下次播放前恢复上次的marker
                if (that.count === 0) {
                  if (that.removeId) {
                    that.addMarkerCluster(that.markerList[that.removeIndex]);
                  }
                  that.closeSrc(true);
                }

                let lat = Number(coordinate.split(",")[1]);
                let lng = Number(coordinate.split(",")[0]);
                that.markerList.forEach((item, index) => {
                  let obj = new TMap.LatLng(
                    item.coordinate.split(",")[1],
                    item.coordinate.split(",")[0]
                  );
                  if (
                    lat === obj.lat &&
                    Number(lng.toFixed(6)) === Number(obj.lng.toFixed(6))
                  ) {
                    that.removeId = item.id;
                    that.removeIndex = index;
                  }
                });

                if (
                  !that.isBuy &&
                  Number(that.markerList[that.removeIndex].type) === 1
                ) {
                  that.showPrizeDialog(that.removeIndex);
                  that.removeId = null;
                  that.removeIndex = null;
                  return;
                }

                audioImg.src = baseImgHost + "/ditu/dongxiap.gif";
                that.markerCluster.remove(that.removeId);
                that.changeSrc(that.removeIndex);
                that.audioMarker.setVisible(true);
                let arr = JSON.parse(JSON.stringify(that.markerList));
                let zoom = that.map.getZoom();
                let num = Number(arr[that.removeIndex].coordinate.split(",")[0]);
                arr[that.removeIndex].coordinate =
                  num + "," + Number(arr[that.removeIndex].coordinate.split(",")[1]);
                that.updateAudioMarker(arr[that.removeIndex]);
              } else {
                that.addMarkerCluster(that.markerList[that.removeIndex]);

                audioImg.src = baseImgHost + "/ditu/zanting.png";
                that.removeId = "";
                that.removeIndex = "";
                that.audioMarker.setVisible(false);
                that.closeSrc();
              }
              that.count++;
            };

           })

          //  this.lineTourMarkerList[index].setVisible(false)
          });








    },
    changeTarberServer() {
      this.changeServerVisible();
      this.markerggregate.setVisible(false);
      // this.markerggregate.getVisible()
      this.labelMapList.forEach((item) => {
        item.setVisible(false);
      });
      window.ClusterBubble.prototype.setVisible(false);

      this.lineTourMarkerList.forEach((item) => {
        item.setVisible(false);
      });
      // this.audioMarker.setVisible(false);
      this.infoWindowMap.close();
    },
    initClusterBubbleProto() {
      let that = this;
      ClusterBubble.prototype = new TMap.DOMOverlay();

      ClusterBubble.prototype.onInit = function (options) {
        this.label = options.label
          ? options.label.substring(0, 4) + "...等"
          : null;
        this.label_eng = options.label_eng
          ? options.label_eng.substring(0, 13) + "..."
          : null;
        this.content = options.content;
        this.position = options.position;
      };

      ClusterBubble.prototype.setVisible = function (bool) {
        let clusterBubbleList = [
          ...document.getElementsByClassName("clusterBubble"),
        ];
        clusterBubbleList.forEach((item) => {
          item.style.display = bool ? "block" : "none";
        });
      };

      // 销毁时需要删除监听器
      ClusterBubble.prototype.onDestroy = function () {
        this.dom.removeEventListener("click", this.onClick);
        this.removeAllListeners();
      };

      // 创建气泡DOM元素
      ClusterBubble.prototype.createDOM = function () {
        this.dom = document.createElement("div");
        this.dom.classList.add("clusterBubble");
        this.dom.className = "clusterBubble";
        this.dom.innerText = this.content;
        this.p = document.createElement("p");
        this.title = document.createElement("div");
        this.p.style.cssText = [
          "width:" + "0;",
          "height: 0;",
          "margin-left: 7px;",
          "border-top: 6.4px solid rgb(231,151,53);",
          "border-right: 3.4px solid transparent;",
          "border-bottom: 6.4px solid transparent;",
          "border-left: 3.4px solid transparent;",
        ].join(" ");

        // this.dom.appendChild(this.p);

        //设置DOM样式
        this.title.style.cssText =
          "height:12px;width: 90px;padding:3.5px 5px;background:#fff;overflow: hidden;border:#ac630c solid 1px;\
                        line-height:15px;font-size:12px;position:absolute;top:36px;left:-45px;overflow:hidden;white-space:normal; word-break:break-all;text-overflow:ellipsis;border-radius: 6px; color:#ac630c; z-index: -100";
        this.title.innerHTML = that.isEnglish ? this.label_eng : this.label;
        this.dom.appendChild(this.title);
        this.dom.style.cssText = [
          "width: " + "21px;",
          "height: " + "21px;",
          "line-height: " + "21px;",
          "background-size:" + "100% 100%;",
          "border-radius: 50%;",
          "border: 2px solid rgb(231,151,53);",
          "background-color: rgb(255,255,255);",
          "font-size: 13px;",
          "font-weight: 500;",
          "text-align: center;",
          "color: rgb(231,151,53);",
          "z-index: 10000000",
        ].join(" ");
        // 监听点击事件，实现zoomOnClick

        // this.onClick = this.onClick.bind(ClusterBubble.prototype.onClick);
        // 点击事件绑定不了 用touchstart事件代替
        // this.dom.addEventListener("touchstart", ClusterBubble.prototype.onClick);
        function tap(dom, callback) {
          // 是否触发了滑动中的事件
          var isMove = false;
          dom.addEventListener(
            "touchstart",
            function (e) {
              callback();
            },
            { passive: false }
          );
        }
        tap(this.dom, function () {
          let zoom = that.map.getZoom();
          that.map.setZoom(zoom + 0.5);
        });
        return this.dom;
      };
      ClusterBubble.prototype.updateDOM = function () {
        that.zoom = that.map.getZoom();
        if (!that.map) {
          return;
        }
        // 经纬度坐标转容器像素坐标
        let pixel = that.map.projectToContainer(this.position);
        // 使文本框中心点对齐经纬度坐标点
        // let left = pixel.getX() + "px";
        // let top = pixel.getY() + "px";
        // this.dom.style.transform = `translate(${left}, ${top})`;

        let left = pixel.getX() - 9.5 + "px"; //本例水平居中
        let top = pixel.getY() - 60 + "px";
        this.dom.style.transform = `translate(${left}, ${top})`;
        //将平面坐标转为三维空间坐标
        // this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
        // this.dom.addEventListener("touchstart", ClusterBubble.prototype.onClick);
        this.emit("dom_updated");
      };

      window.ClusterBubble = ClusterBubble;
    },
    initMyInfoWindowProto() {
      let that = this;
      myInfoWindow.prototype = new TMap.DOMOverlay();
      // 创建DOM元素，返回一个DOMElement
      myInfoWindow.prototype.createDOM = function () {
        let mydom = document.createElement("div");
        //设置DOM样式
        mydom.style.cssText =
          "height:12px;padding:3.5px 8px;background:#fff;overflow: hidden;border:#ac630c solid 1px;\
                        line-height:15px;font-size:12px;position:absolute;top:0px;left:0px;border-radius: 6px; color:#ac630c; z-index: -100";
        mydom.innerHTML = this.content;
        this.dom = mydom;
        return mydom;
      };
      // 更新DOM元素，在地图移动/缩放后执行
      myInfoWindow.prototype.updateDOM = function () {
        if (!that.map) {
          return;
        }

        // 经纬度坐标转容器像素坐标
        let pixel = that.map.projectToContainer(this.position);

        //默认使用DOM左上角作为坐标焦点进行绘制（左上对齐）
        //如想以DOM中心点（横向&垂直居中）或其它位置为焦点，可结合this.dom.clientWidth和this.dom.clientHeight自行计算
        let left = pixel.getX() - this.dom.clientWidth / 2 + "px"; //本例水平居中
        let top = pixel.getY() + 46 + "px";

        //将平面坐标转为三维空间坐标
        this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
      };

      myInfoWindow.prototype.setVisible = function (bool) {
        if (bool) {
          this.dom.style.display = "block";
          // 经纬度坐标转容器像素坐标
          let pixel = that.map.projectToContainer(this.position);

          //默认使用DOM左上角作为坐标焦点进行绘制（左上对齐）
          //如想以DOM中心点（横向&垂直居中）或其它位置为焦点，可结合this.dom.clientWidth和this.dom.clientHeight自行计算
          let left = pixel.getX() - this.dom.clientWidth / 2 + "px"; //本例水平居中
          let top = pixel.getY() + 46 + "px";

          //将平面坐标转为三维空间坐标
          this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
        } else {
          this.dom.style.display = "none";
        }
      };

      myInfoWindow.prototype.setContent = function (bool) {
        if (this.type !== "server") {
          this.content = bool
            ? that.markerList[this.index].name_eng
            : that.markerList[this.index].name;
        } else {
          this.content = bool
            ? that.inlet_and_outlet[this.index].name_eng
            : that.inlet_and_outlet[this.index].name;
        }
        this.dom.innerHTML = this.content;
      };
    },

    initAddressProto() {
      let that = this;
      addressMasker.prototype = new TMap.DOMOverlay();
      // 创建DOM元素，返回一个DOMElement
      addressMasker.prototype.createDOM = function () {
        let mydom = document.createElement("div");
        //设置DOM样式
        // mydom.style.cssText =
        //   "height:12px;max-width:120px;padding:3.5px 5px;background:#fff;border:#ac630c solid 1px;\
        //                   line-height:15px;font-size:12px;position:absolute;top:0px;left:0px;border-radius: 6px; color:#ac630c";
        mydom.innerHTML = this.content;
        return mydom;
      };
      // 更新DOM元素，在地图移动/缩放后执行
      addressMasker.prototype.updateDOM = function () {
        if (!that.map) {
          return;
        }
        // 经纬度坐标转容器像素坐标
        let pixel = that.map.projectToContainer(this.position);
        //默认使用DOM左上角作为坐标焦点进行绘制（左上对齐）
        //如想以DOM中心点（横向&垂直居中）或其它位置为焦点，可结合this.dom.clientWidth和this.dom.clientHeight自行计算
        let left = pixel.getX() - 20 + "px"; //本例水平居中
        let top = pixel.getY() + "px";

        //将平面坐标转为三维空间坐标
        this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
      };
      addressMasker.prototype.setPosition = function (position) {
        this.position = position;
        this.updateDOM();
      };
    },
    // 初始化地图和数据
    getAddress(data, list) {
      // compatibleAndroid();
      // console.log(data, list, 5656565);
      this.contentData = data;
      this.markerList = list;
      this.second_service_category = data.second_service_category;
      this.inlet_and_outlet = data.inlet_and_outlet.concat(data.second_service);
      // console.log(this.inlet_and_outlet)
      this.second_service = data.second_service;
      let showBackImg = Number(data.showBackImg) === 1;
      let mapCenter = new TMap.LatLng(
        data.coordinate.split(",")[1],
        data.coordinate.split(",")[0]
      );

      this.map.setCenter(mapCenter);
      this.map.setZoom(data.mapZoom || 18);
      // 设置地图边界
      // this.setBoundary(data.boundary, data);
      let that = this;
      // 点击地图关闭信息窗口
      this.initMapEvent();
      // 移除地图控件
      this.removeControl();
      // 设置地图距离
      // 如果需要展示景区背景图,则初始化瓦片地图
      if (showBackImg) {
        this.initImg();
      }
      // 1 支持自动播放 2 不支持自动播放
      // 初始化自从播放范围
      if (data.autoPlay !== 2) {
        this.initCircle();
        this.initRadiusArr(list);
        this.initLagLngArr(list);
      }
      // 覆盖折线
      this.setLine();
      // // 创建label
      this.initLabel();
      // // 创建点聚合
      this.initMaskerCluster();
      // // // 初始化信息窗口
      this.initInfoWindow();
      // // 初始化播放中的marker
      this.initAudioMarker();
      // // 初始化服务中心地理位置
      this.initServerAddress();
      // // 初始化服务中心信息窗口
      this.infoServerWindow();
      // // 初始化当前地图位置标记
      this.initAddressMarker();
      // 定义地图范围
      if (data.isDrag != 1) {
        this.setBoundary(data);
      }
      setTimeout(() => {
        this.searchPlayStatus();
      }, 1800);
      // // 判断是否购买过
      // this.searchBuy();
    },
    initMapEvent() {
      let that = this;
      this.map.on("click", (event) => {
        if(this.isInfoClose == false){
          this.isInfoClose = true;
        }else{
          this.infoWindowMap.close();
          this.infoServerMap.close();
        }
        // 如果是未开启播放或暂停播放模式, 重置audio播放数据,下次重新开始播放
        if (this.count % 2 === 0) {
          this.count = 0;
        }

        eventBus.emit("closeTab");
      });
    },
    searchPlayStatus() {
      let that = this;

      if (play_id && !sessionStorage.getItem("isPlay")) {
        that.removeIndex = that.markerList.findIndex((item) => {
          return item.id === play_id;
        });

        that.removeId = play_id;

        if (
          !that.isBuy &&
          Number(that.markerList[that.removeIndex].type) === 1
        ) {
          sessionStorage.setItem("isPlay", true);
          that.showPrizeDialog(that.removeIndex);
          that.removeId = null;
          that.removeIndex = null;
          return;
        }
        // 删除聚合中该id的marker
        that.markerCluster.remove(play_id);
        // 展示播放中的marker
        that.audioMarker.setVisible(true);
        // 开启音乐
        that.changeSrc(that.removeIndex);
        sessionStorage.setItem("isPlay", true);
        // 播放状态标识+1
        that.count++;

        // 更新播放中marker至当前播放位置
        that.updateAudioMarker(that.markerList[that.removeIndex]);
        eventBus.emit("playIcon", "playing");
        that.changeInfoWindowVisbel(that.markerList[that.removeIndex]);
        // that.changeSrc();
      }
    },
    setBoundary(data) {
      let boundaryArr = data.boundary;
      let sw = new TMap.LatLng(boundaryArr[1][0], boundaryArr[0][1]);
      let ne = new TMap.LatLng(boundaryArr[0][0], boundaryArr[1][1]);
      let boundary = new TMap.LatLngBounds(sw, ne);
      this.map.setBoundary(boundary);
    },
    changeInfoWindowVisbel(message) {
      console.log(message);
      let that = this;
      let coordinate = message.coordinate;

      this.map.setZoom(this.contentData.mapZoom || 18);
      this.map.easeTo(
        {
          center: new TMap.LatLng(
            coordinate.split(",")[1],
            coordinate.split(",")[0]
          ),
        },
        { duration: 700 }
      );

      this.infoWindowMap.open();
      this.infoWindowMap.setPosition(
        new TMap.LatLng(coordinate.split(",")[1], coordinate.split(",")[0])
      );

      // 设置信息窗位置
      this.infoWindowMap.setContent(
        message.link_spot ? templateContent : templateContent2
      ); // 设置信息窗内容
      // 根据语言状态切换对应文本
      this.changeWindowDomText(this.isEnglish);
      let lat = Number(coordinate.split(",")[1]);
      let lng = Number(coordinate.split(",")[0]);
      let windowInfoIndex = null;
      let infoImg = document.getElementById("infoImg");

      let detail = document.getElementById("detail");
      $(detail).html(message.content)
      let windowInfoTitle = document.getElementById("windowInfoTitle");
      this.changeInfoWindowDomText(this.markerList, lat, lng);

      //信息框解说和详情的点击事件
      let info = document.getElementById("info");
      let audioInfo = document.getElementById("audioInfo");
      let audioImg = document.getElementById("audioImg");
      let tourInfo = document.getElementById("tour");
      let tourDaolanMap = document.getElementById("tourDaolan")
       var ua = navigator.userAgent.toLowerCase();
      if (tourInfo) {
        tourInfo.onclick = () => {
          window.open(message.link_spot);
        };
      }
      if(tourDaolanMap){
              tourDaolanMap.onclick=()=>{
                // console.log(that.choseMarker)
                 let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${that.spointx}&spointy=${that.spointy}&epointx=${lat}&epointy=${lng}&eword=${message?message.name:""}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;

                 if (ua.match(/MicroMessenger/i) != "micromessenger") {
                    window.open(herf)
                 }else{
                   that.$wx.openLocation({
                      latitude: lat,
                      longitude: lng,
                      scale: 18,
                      success: function (res) {
                        // alert(JSON.stringify(res))
                      },
                      fail: function (err) {
                        // alert(JSON.stringify(err))
                      },
                    });
                 }
              }
            }

      if(info){
        info.onclick = () => {
        let lat = Number(coordinate.split(",")[1]);
        let lng = Number(coordinate.split(",")[0]);
        that.infoWindowEvent(that.markerList, lat, lng);
      };
      }


      if (message.id === that.removeId) {
        audioImg.src = baseImgHost + "/ditu/dongxiap.gif";
      } else {
        audioImg.src = baseImgHost + "/ditu/erji2.png";
      }
      //播放按钮点击
      audioInfo.onclick = () => {
         that.$emit("audioOpen",true)
        if (that.count % 2 === 0) {
          // 如果信息框切换并且有播放的那个id,说明上个歌曲还在播放状态,需要在下次播放前恢复上次的marker
          if (that.count === 0) {
            if (that.removeId) {
              that.addMarkerCluster(that.markerList[that.removeIndex]);
            }
            that.closeSrc(true);
          }

          let lat = Number(coordinate.split(",")[1]);
          let lng = Number(coordinate.split(",")[0]);
          that.markerList.forEach((item, index) => {
            let obj = new TMap.LatLng(
              item.coordinate.split(",")[1],
              item.coordinate.split(",")[0]
            );
            if (
              lat === obj.lat &&
              Number(lng.toFixed(6)) === Number(obj.lng.toFixed(6))
            ) {
              that.removeId = item.id;
              that.removeIndex = index;
            }
          });

          if (
            !that.isBuy &&
            Number(that.markerList[that.removeIndex].type) === 1
          ) {
            that.showPrizeDialog(that.removeIndex);
            that.removeId = null;
            that.removeIndex = null;
            return;
          }

          audioImg.src = baseImgHost + "/ditu/dongxiap.gif";
          that.markerCluster.remove(that.removeId);
          that.changeSrc(that.removeIndex);
          that.audioMarker.setVisible(true);
          let arr = JSON.parse(JSON.stringify(that.markerList));
          let zoom = that.map.getZoom();
          let num = Number(arr[that.removeIndex].coordinate.split(",")[0]);
          arr[that.removeIndex].coordinate =
            num + "," + Number(arr[that.removeIndex].coordinate.split(",")[1]);
          that.updateAudioMarker(arr[that.removeIndex]);
        } else {
          that.addMarkerCluster(that.markerList[that.removeIndex]);

          audioImg.src = baseImgHost + "/ditu/zanting.png";
          that.removeId = "";
          that.removeIndex = "";
          that.audioMarker.setVisible(false);
          that.closeSrc();
        }
        that.count++;
      };
    },
    hideLogo() {
      let logoText = [...document.getElementsByClassName("logo-text")];
      let rotateCircle = [...document.getElementsByClassName("rotate-circle")];
      rotateCircle.forEach((item) => {
        item.style.display = "none";
      });
      logoText.forEach((item) => {
        item.innerText = "";
      });
      let tmapScaleControl = [
        ...document.getElementsByClassName("tmap-scale-control"),
      ];
      tmapScaleControl.forEach((item) => {
        item.innerHTML = "";
      });
    },

    setMap(arr, data) {
      let boundaryArr = arr;

      // 初始化地图
      this.map = new TMap.Map("mapTop", {
        // center: new TMap.LatLng(
        //   data.coordinate.split(",")[1],
        //   data.coordinate.split(",")[0]
        // ), // 地图显示中心点
        center: new TMap.LatLng(35.861447, 104.198068),
        minZoom: 10,
        maxZoom: 20,
        zoom: 10,

        viewMode: "2D",

        showControl: false,
        baseMap: {
          // 如果是需要展示背景图,则什么都不展示,如果不展示背景图,只需要隐藏地图文字
          features: ["base", "label", "road"], // 隐藏矢量文字
        },
      });
    },
    changeWindowDomText(bool) {
      // console.log(bool, 1111);
      let commentary = document.getElementById("commentary");
      // let detailBtn = document.getElementById("detailBtn");
      if (bool && commentary) {
        commentary.parentElement.style.width = "93px";
        commentary.parentElement.style.marginRight = "13px";
      } else if (!bool && commentary) {
        commentary.parentElement.style.width = "73px";
        commentary.parentElement.style.marginRight = "0";
      }
      if (commentary) {
        commentary.innerText = bool
          ? infoPlayEnglishMap[0].english
          : infoPlayEnglishMap[0].chinese;

      }
    },
    changeEngStatus(bool) {
      this.isEnglish = bool;
      // 切换window弹窗中英文
      this.changeWindowDomText(bool);
      // 切换label中英文
      this.changeLabelText(bool);
      // 切换去这里弹窗文本
      this.changeAddressDomText(this.infoServerData, bool);
      // 切换window弹窗动态数据
      this.changeActiveWindowText(this.windowInfoIndex, bool);
      // 点聚合自定义文本中英文切换
      this.changeGatherLabel(bool);
    },
    changeAddressDomText(data, bool) {
      let serverName = document.getElementById("serverName");
      if (serverName) {
        serverName.innerHTML = bool ? data.name_eng : data.name;
      }
    },
    changeGatherLabel(bool) {
      //  console.log(this.clusterBubbleList)
      this.clusterBubbleList.forEach((item) => {
        if (bool) {
          item.title.innerHTML = item.label_eng;
        } else {
          item.title.innerHTML = item.label;
        }
      });
    },
    changeActiveWindowText(ind, bool) {
      if (ind !== null) {
        let windowInfoTitle = document.getElementById("windowInfoTitle");
        let detail = document.getElementById("detail");
        if (windowInfoTitle) {
          windowInfoTitle.innerHTML = bool
            ? this.markerList[ind].name_eng
            : this.markerList[ind].name;
          detail.innerHTML = bool
            ? this.markerList[ind].content_eng
            : this.markerList[ind].content;
        }
      }
    },
    // label表示切换中英文
    changeLabelText(bool) {
      this.labelMapList.forEach((item) => {
        item.setContent(bool);
        item.updateDOM();
      });
      this.serverLabelList.forEach((item) => {
        item.setContent(bool);
        item.updateDOM();
      });
    },
    initRadiusArr(arr) {
      // 可自动播放点位集合
      this.CircleRadiusArr = arr.map((item) => {
        return item.radiusRice;
      });
    },
    // 景点点位数组,提前计算出来,减少自动播放时的多余计算
    initLagLngArr(list) {
      this.LanLngArr = list.map((item) => {
        let arr = item.coordinate.split(",");
        return new TMap.LatLng(arr[1], arr[0]);
      });
    },
    // 自动播放关闭时重置上次播放的音频
    changeAutomaticId() {
      this.automaticId = null;
    },

    setMapCenterOnce() {
      let boundary = this.contentData.boundary;
      // 判断用户当前位置是否超出边界值
      // alert(boundary,3)

      // alert(this.spointx,1)
      // alert(this.spointy,2)

      if (
        this.spointx > boundary[1][0] &&
        this.spointx < boundary[0][0] &&
        this.spointy > boundary[0][1] &&
        this.spointy < boundary[1][1]
      ) {
        this.map.setCenter(new TMap.LatLng(this.spointx, this.spointy));
      } else {
        this.$parent.showMessage(
          `${
            this.isEnglish
              ? messageEnglishMap[1].english
              : messageEnglishMap[1].chinese
          }`
        );
        // let eword = this.contentData.address;
        // let epointx = this.contentData.coordinate.split(",")[1];
        // let epointy = this.contentData.coordinate.split(",")[0];
        // let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${this.spointx}&spointy=${this.spointy}&epointx=${epointx}&epointy=${epointy}&eword=${eword}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;
        // window.open(herf)
      }
    },

    infoServerWindow() {
      this.infoServerMap = new TMap.InfoWindow({
        map: this.map,
        zIndex: 1000,
        position: new TMap.LatLng(39.984104, 116.307503),
        offset: { x: 0, y: 0 }, // 设置信息窗相对position偏移像素
      });
      this.infoServerMap.close();
    },
    // 初始化自动播放范围
    initCircle() {
      this.CircleLine = new TMap.MultiCircle({
        map: this.map,
        zIndex: 100000,
        geometries: [
          {
            styleId: "circle",
            radius: 200,
            center: new TMap.LatLng(39.706238, 116.320828),
          },
        ],
        styles: {
          // 设置圆形样式
          circle: new TMap.CircleStyle({
            color: "rgba(41,91,255,0.16)",
            showBorder: true,
            borderColor: "#0099FF",
            borderWidth: 2,
          }),
        },
      });
      this.CircleLine.setVisible(false);
    },

    initServerAddress() {
      let that = this;

      this.inlet_and_outlet.forEach((item, index) => {
        this.serverMarkerList[index] = new TMap.MultiMarker({
          id: item.id, // 图层id

          map: this.map,

          styles: {
            // 点标注的相关样式
            marker: new TMap.MarkerStyle({
              width: 35,
              height: 35,
              anchor: { x: 17.5, y: -8 },
              src: item.icon,
            }),
          },

          geometries: [
            {
              // 点标注数据数组
              id: "demo",
              styleId: "marker",
              position: new TMap.LatLng(
                item.longitude.split(",")[1],
                item.longitude.split(",")[0]
              ),
              properties: {
                title: "marker",
              },
            },
          ],
        });

        this.serverMarkerList[index].setVisible(false);

        this.serverMarkerList[index].on("click", (evt) => {
          that.isInfoClose = false
          that.infoServerMap.open();
          that.infoServerMap.setPosition(evt.geometry.position); // 设置信息窗位置
          let data = that.inlet_and_outlet[index];
          let eword = data.text;
          that.infoServerData = data;
          let epointx = data.longitude.split(",")[1];
          let epointy = data.longitude.split(",")[0];
          // let herf;
          let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${that.spointx}&spointy=${that.spointy}&epointx=${epointx}&epointy=${epointy}&eword=${eword}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;

          // console.log(data)

          that.infoServerMap.setContent(
            `<div style="padding: 0 13px; font-size: 13px" >
             <a   style='width: 18px; height: 40px; line-height:40px; display: inline-block' />
             <img id="openditu" src="${baseImgHost}/ditu/daohang.png" style="width: 18px; height: 18px"></a><p style="display: inline-block; margin-left: 16px;  line-height: 40px;    vertical-align: top;"><span id='serverName'>
            <span id="erjidaolan"> ${that.isEnglish ? data.name_eng : data.name}</span>

              </div>`
          );
            var ua = navigator.userAgent.toLowerCase();



           $("#openditu").on("click", () => {
            //  alert(123456798);
            if (ua.match(/MicroMessenger/i) != "micromessenger") {
              // if(data.link_spot){
                window.location.href = herf;
              // }
            } else {

              let lat=data.longitude.split(",")[0]
              let lon=data.longitude.split(",")[1]
              setTimeout(()=>{
                this.$wx.openLocation({
                latitude: parseFloat(epointx),
                longitude: parseFloat(epointy),
                scale: 18,
                success: function (res) {

                },
                fail: function (err) {

                },
              });
              },700)
            }

           })

          //跳转二级导览
          // let erjidaolan=document.getElementById("erjidaolan")
          $("#erjidaolan").on("click", () => {

            if(data.link_spot){

              window.location.href=data.link_spot
              }else{
                //判断不是在微信端打开
                if (ua.match(/MicroMessenger/i) != "micromessenger") {
                // if(data.link_spot){
                  window.location.href = herf;
                // }
              } else {

                let lat=data.longitude.split(",")[0]
                let lon=data.longitude.split(",")[1]
                // alert(lat)
                // alert(lon)
                // alert(typeOf(parseFloat(lat)))
                this.$wx.openLocation({
                  latitude: parseFloat(lat),
                  longitude: parseFloat(lon),
                  scale: 18,
                  success: function (res) {
                    // alert(JSON.stringify(res))
                  },
                  fail: function (err) {
                    // alert(JSON.stringify(err))
                  },
                });
              }
            }
          });
        });

        this.serverLabelList[index] = new myInfoWindow({
          map: this.map,
          position: new TMap.LatLng(
            item.longitude.split(",")[1],
            item.longitude.split(",")[0]
          ), // 标注点位置
          content: item.name,
          id: item.id,
          index,
          type: "server",
        });
        this.serverLabelList[index].setVisible(false);
      });
    },
    drawImg(bool) {
      if (!bool) {
        // this.earthlayer.setVisible(false);
        this.earthlayer.forEach((item) => {
          item.setVisible(false);
        });
        this.map.setBaseMap({ features: ["base", "building2d"] });
      } else {
        // this.earthlayer.setVisible(true);
        this.earthlayer.forEach((item) => {
          item.setVisible(true);
        });
      }
    },
    initAddressMarker() {
      let headimgurl =
        JSON.parse(sessionStorage.getItem("openIdData") || "{}").headimgurl ||
        "https://www1.xiaoniren.cn/saasapi/image/defaultheading.png";
      // alert(this.$props.lat,this.$props.lon)

      this.addressMarker = new addressMasker({
        map: this.map, // 指定地图容器
        position: new TMap.LatLng(this.$props.lat, this.$props.lon), // 点标记坐标位置
        content: `<div style='background: url(${baseImgHost}/ditu/addressborder.png) no-repeat center center; background-size: 100% 100%; position: relative;width: 39px; height: 42px'>
            <img src=${headimgurl} style='width: 26px; height: 26px; position: absolute;border-radius: 50%; left: 6.5px; top: 3px'>
            </div>`,
      });
    },
    computedBoundary(boundary, lag, lng) {
      if (
        lag > boundary[1][0] &&
        lag < boundary[0][0] &&
        lng > boundary[0][1] &&
        lng < boundary[1][1]
      ) {
        return true;
        // 更新位置
      } else {
        // 不在景区范围
        return false;
      }
    },
    // 监听用户位置更改触发
    setCenter(lag, lng, isOpenAudio) {
      this.spointx = lag;
      this.spointy = lng;

      // 是否在景区范围
      let boundary = this.contentData.boundary;
      let isBoundary = this.computedBoundary(boundary, lag, lng);
      if (isBoundary) {
        this.addressMarker.setPosition(new TMap.LatLng(lag, lng));
      } else {
        eventBus.emit(
          "showMessage",
          `${
            this.isEnglish
              ? messageEnglishMap[1].english
              : messageEnglishMap[1].chinese
          }`
        );
      }

      // 如果是自动播放模式, 给经纬度数组中每一项作比较,如果用户位置没有超出其中的范围,则播放该歌曲
      if (isOpenAudio) {
        let parselag = Number(lag.toFixed(5));
        let parseLng = Number(lng.toFixed(5));
        let newLagLng = new TMap.LatLng(lag, lng);
        // 获取当前用户位置距离景点的位置数组
        let distanceArr = this.markerList.map((item, index) => {
          let path = [newLagLng, this.LanLngArr[index]];
          let distance = TMap.geometry.computeDistance(path);
          return distance;
        });
        let findArr = [];
        this.markerList.forEach((item, index) => {
          // 距离每个位置的距离
          let distance = distanceArr[index];
          // 每个点可自动播放的最大距离
          let radius = this.CircleRadiusArr[index];
          // 返回在距离点景区, 重新组合为一个新数组
          if (distance <= radius) {
            findArr.push({
              data: item,
              distance,
              ind: index,
            });
          }
        });
        // 如果没有找到符合条件的景点位置, 则直接返回
        if (!findArr.length) {
          this.CircleLine.setVisible(false);
          // this.closeSrc(true)
          return;
        }
        // 给当前用户所有符合条件的点位以距离排序,返回距离最近的那个
        let sortArr = findArr.sort((a, b) => {
          return a.distance - b.distance;
        });
        // 最终取得距离最近的点位
        let findItem = this.markerList[sortArr[0].ind];
        // 距离最近的点位的索引
        let findIndex = sortArr[0].ind;
        // 如果上一个播放的id和这次筛选出来的id一致,说明该用户没有超过上次的景点边界范围,不需要做任何处理,反之,开启播放音乐
        if (this.automaticId !== findItem.id) {
          if (this.removeId) {
            this.addMarkerCluster(this.markerList[this.removeIndex]);
          }
          this.closeSrc(true);
          // 赋值/重新赋值
          this.automaticId = findItem.id;
          this.removeIndex = findIndex;
          this.removeId = findItem.id;
          // 如果该歌曲为付费歌曲, 开启支付弹窗并返回重置数据
          if (
            !this.isBuy &&
            Number(this.markerList[this.removeIndex].type) === 1
          ) {
            this.showPrizeDialog(this.removeIndex);
            this.removeIndex = null;
            this.removeId = null;
            // this.utomaticId = null
            this.isShowPrizeCount = 1;
            return;
          }
          // 开启自动播放范围的圆圈
          this.CircleLine.setVisible(true);
          this.CircleLine.setGeometries([
            {
              styleId: "circle",
              radius: this.CircleRadiusArr[this.removeIndex],
              center: this.LanLngArr[this.removeIndex],
            },
          ]);
          // 删除聚合中该id的marker
          this.markerCluster.remove(this.removeId);
          // 展示播放中的marker
          this.audioMarker.setVisible(true);
          // 开启音乐
          this.changeSrc(this.removeIndex);
          // 播放状态标识+1
          this.count++;
          // 更新播放中marker至当前播放位置
          this.updateAudioMarker(this.markerList[this.removeIndex]);
        }
      }
    },
    updateAudioMarker(message) {
      this.audioMarker.updateGeometries([
        {
          id: "1", // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: "myStyle", // 指定样式i
          position: new TMap.LatLng(
            message.coordinate.split(",")[1],
            message.coordinate.split(",")[0]
          ),
          // 点标记坐标位置
          properties: {
            // 自定义属性
            title: "marker1",
          },
        },
      ]);
    },
    addMarkerCluster(message) {
      this.markerCluster.add({
        position: new TMap.LatLng(
          message.coordinate.split(",")[1],
          message.coordinate.split(",")[0]
        ),
        id: this.removeId,
      });
    },
    changeAudioState() {
      this.count = 0;
      let audioImg = document.getElementById("audioImg");
      this.addMarkerCluster(this.markerList[this.removeIndex]);

      if (audioImg) {
        audioImg.src = baseImgHost + "/ditu/erji2.png";
      }
      this.audioMarker.setVisible(false);
      this.closeSrc(true);
      // this.automaticId = null
      this.removeId = null;
      this.removeIndex = null;
    },
    initAudio() {
      this.audioMarker = new TMap.MultiMarker({
        map: this.map,

        styles: {
          // 创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          myStyle: new TMap.MarkerStyle({
            width: 38, // 点标记样式宽度（像素）
            height: 38, // 点标记样式高度（像素）
            src: baseImgHost + "/ditu/bofang2.png", // 图片路径
            // 焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            anchor: { x: 19, y: 0 },
          }),
        },
        geometries: [
          {
            id: "1", // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            styleId: "myStyle", // 指定样式id
            position: new TMap.LatLng(26.873605, 100.239804), // 点标记坐标位置
            properties: {
              // 自定义属性
              title: "marker1",
            },
          },
        ],
      });
    },
    initAudioMarkerEvent() {
      let that = this;
      //点击事件
      this.audioMarker.on("click", (evt) => {

        let arr = JSON.parse(JSON.stringify(that.markerList));
        let num = Number(arr[that.removeIndex].coordinate.split(",")[0]);
        arr[that.removeIndex].coordinate =
          num + "," + Number(arr[that.removeIndex].coordinate.split(",")[1]);
        // 如果信息弹窗为关闭状态,开启信息弹窗
        if (that.isInfoClose) {
          // 打开信息窗
          that.infoWindowMap.open();
          // 设置信息窗位置
          that.infoWindowMap.setPosition(evt.geometry.position);

          // 设置播放时信息框内容
          that.infoWindowMap.setContent(templateContent);
          that.changeWindowDomText(that.isEnglish);
          // 点击时的经纬度
          let lat = evt.geometry.position.lat;
          let lng = evt.geometry.position.lng;
          let audioImg = document.getElementById("audioImg");
          let windowInfoIndex = null;
          let infoImg = document.getElementById("infoImg");
          let detail = document.getElementById("detail");
          let windowInfoTitle = document.getElementById("windowInfoTitle");
          // 查找出点击时的经纬度和经纬度列表中经纬度一直的那一项
          audioImg.src = baseImgHost + "/ditu/dongxiap.gif";
          that.changeInfoWindowDomText(arr, lat, lng);

          let info = document.getElementById("info");
          let audioInfo = document.getElementById("audioInfo");
          let tourInfo = document.getElementById("tour");

          tourInfo.onclick = () => {
            // console.log(132456789);
          };
          // 给详情按钮添加点击事件,展示弹窗
          info.onclick = () => {
            let lat = evt.geometry.position.lat;
            let lng = evt.geometry.position.lng;
            that.infoWindowEvent(arr, lat, lng);
          };

          // 播放按钮点击
          audioInfo.onclick = () => {
            // 播放
            // console.log(123456789)
            if (that.count % 2 === 0) {
              let lat = evt.geometry.position.lat;
              let lng = evt.geometry.position.lng;
              that.markerCluster.remove(that.removeId);
              arr.forEach((item, index) => {
                let obj = new TMap.LatLng(
                  item.coordinate.split(",")[1],
                  item.coordinate.split(",")[0]
                );
                if (
                  lat === obj.lat &&
                  Number(lng.toFixed(6)) === Number(obj.lng.toFixed(6))
                ) {
                  that.removeId = item.id;
                  that.removeIndex = index;
                }
              });
              audioImg.src = baseImgHost + "/ditu/dongxiap.gif";
              that.changeSrc(that.removeIndex);
              that.audioMarker.setVisible(true);
              that.updateAudioMarker(arr[that.removeIndex]);
            }
            // 暂停
            else {
              that.addMarkerCluster(that.markerList[that.removeIndex]);
              audioImg.src = baseImgHost + "/ditu/zanting.png";
              that.audioMarker.setVisible(false);
              that.closeSrc();
            }
            that.count++;
          };
        }
        this.isInfoClose = false;
      });
    },
    changeInfoWindowDomText(arr, lat, lng) {
      let that = this;
      let windowInfoIndex;
      arr.forEach((item, index) => {
        let obj = new TMap.LatLng(
          item.coordinate.split(",")[1],
          item.coordinate.split(",")[0]
        );
        if (
          lat === obj.lat &&
          Number(lng.toFixed(6)) === Number(obj.lng.toFixed(6))
        ) {
          // 赋值信息框数据
          // console.log(item,windowInfoIndex,index)
          that.choseMarker = item;

          windowInfoIndex = index;
          that.windowInfoIndex = index;
          infoImg.src = imgHost + item.img;
          detail.innerHTML = that.isEnglish ? item.content_eng : item.content;

          windowInfoTitle.innerText = that.isEnglish
            ? item.name_eng
            : item.name;
        }
      });
    },
    // 初始化播放时的marker
    initAudioMarker() {
      let that = this;
      this.initAudio();
      this.initAudioMarkerEvent();
      this.audioMarker.setVisible(false);
    },

    // 初始化信息窗口
    initInfoWindow() {
      this.infoWindowMap = new TMap.InfoWindow({
        map: this.map,
        zIndex: 1000,
        position: new TMap.LatLng(39.984104, 116.307503),
        offset: { x: 0, y: -8 }, // 设置信息窗相对position偏移像素
      });
      let that = this;
      // 监听信息弹窗关闭,如果是暂停模式或未开启模式那么重置播放数据
      this.infoWindowMap.on("closeclick", () => {
        this.isInfoClose = true;
        if (that.count % 2 === 0) {
          that.count = 0;
        }
      });
      this.infoWindowMap.close();
      this.isInfoClose = true;
    },

    // 创建label
    initLabel(ind,type) {

      let list = this.markerList;
      // console.log(this.markerList)

        if (ind) {
        list = this.markerList.filter((item, index) => {
          return ind === index;
        });
      }
        list.forEach((item, index) => {
          this.labelMapList[index] = new myInfoWindow({
            map: this.map,
            position: new TMap.LatLng(
              item.coordinate.split(",")[1],
              item.coordinate.split(",")[0]
            ), // 标注点位置
            content: item.name,
            id: item.id,
            index,
            type: "scenic",
          });
        });



    },

    // 支付弹窗
    showPrizeDialog(index) {
      this.$emit("showPrizeDialog");
      // }
    },

    initMarkerClusterStyle(geometries) {
      let boundaryArr = this.contentData.boundary;
      // 定义地图范围
      this.markerCluster=""
      this.markerCluster = new TMap.MarkerCluster({
        id: "cluster",
        map: this.map,
        // 关闭默认样式
        enableDefaultStyle: false,
        // 最小可聚合数量
        minimumClusterSize: 3,
        // 位置
        geometries,
        // 可聚合距离
        gridSize: 70,
        // 聚合点是否按照平均值排布
        averageCenter: true,
        // 可聚合最大层级
        maxZoom: (this.contentData.mapZoom || 18) - 1,
        zIndex: -1,
      });
    },
    // 创建点聚合
    initMaskerCluster() {
      let drawContainer = document.getElementById("mapTop");
      let geometries = [];
      this.clusterBubbleList = [];
      let markerGeometries = [];
      // let marker = null
      // console.log(this.markerList, 132456789);

      this.markerList.forEach((item, index) => {
        geometries.push({
          position: new TMap.LatLng(
            item.coordinate.split(",")[1],
            item.coordinate.split(",")[0]
          ),
          id: item.id,
          label: item.name,
          label_eng: item.name_eng,
        });
      });
      // console.log(geometries, 5555555555);
      this.initMarkerClusterStyle(geometries);

      let that = this;
      // 聚合事件
      this.markerCluster.on("cluster_changed", function (event) {
        that.zoom = that.map.getZoom();
        if (that.markerggregate) {
          // 如果tab点击服务中心或本身就不展示,不做任何处理
          if (
            that.activeIndex === 2 ||
            that.markerggregate.getVisible() === false
          ) {
            return;
          }
        }
        // 销毁旧聚合簇生成的覆盖物
        if (that.clusterBubbleList.length) {
          that.clusterBubbleList.forEach(function (item) {
            // console.log(item,123456)
            item.destroy();
          });
          that.clusterBubbleList = [];
        }
        markerGeometries = [];
        // 根据新的聚合簇数组生成新的覆盖物和点标记图层
        let clusters = that.markerCluster.getClusters();

        // marker
        clusters.forEach(function (item, index) {
          // 聚合层
          let firstItemLabel = null;
          let firstIndex = null;
          if (item.geometries.length > 1) {
            let position = that.infoWindowMap.position;
            let remnantItem = "";

            for (let i = 0; i < item.geometries.length; i++) {
              if (
                item.geometries[i].position.lat === position.lat &&
                item.geometries[i].position.lng.toFixed(6) ===
                  position.lng.toFixed(6)
              ) {
                that.infoWindowMap.close();
              }
              // 隐藏符合条件的聚合层label
              let findIndex = that.markerList.findIndex((ite) => {
                return ite.id === item.geometries[i].id;
              });
              // 如果当前正在播放中, 不隐藏这个label
              if (that.removeId === that.markerList[findIndex].id) continue;
              that.labelMapList[findIndex].setVisible(false);
            }

            let clusterBubble = new ClusterBubble({
              map: that.map,
              position: item.center,
              content: item.geometries.length,
              label: item.geometries[0].label,
              label_eng: item.geometries[0].label_eng,
            });

            clusterBubble.on("click", () => {
              that.map.fitBounds(item.bounds);
            });
            that.clusterBubbleList.push(clusterBubble);

            let indexList = [];
            let averageLatSum = 0;
            let averageLngSum = 0;

            item.geometries.forEach((item) => {
              that.markerList.forEach((ite, ind) => {
                if (item.id === ite.id) {
                  indexList.push([ite, ind]);
                }
              });
            });
          } else {
            // 展示label
            markerGeometries.push({
              position: item.center,
            });
            let id = item.geometries[0].id;
            let findIndex = that.markerList.findIndex((item) => {
              return item.id === id;
            });
            let geometries = [
              {
                id: that.markerList[findIndex].id, // 点图形数据的标志信息

                styleId: "label", // 样式id

                position: new TMap.LatLng(
                  that.markerList[findIndex].coordinate.split(",")[1],
                  that.markerList[findIndex].coordinate.split(",")[0]
                ), // 标注点位置

                content: `${that.markerList[findIndex].name}`, // 标注文本
                properties: {
                  // 标注点的属性数据
                  title: "label",
                },
              },
            ];
            that.labelMapList[findIndex].setVisible(true);
          }
        });

        if (that.markerggregate) {
          // 已创建过点标记图层，直接更新数据
          that.geometries = that.markerggregate.geometries;
          that.markerggregate.setGeometries(markerGeometries);
        } else {
          // 创建点标记图层
          //景点marker点
          // console.log(that.markerList[0].icon)
          that.markerggregate = new TMap.MultiMarker({
            map: this.map,
            styles: {
              default: new TMap.MarkerStyle({
                width: 38,
                height: 38,
                anchor: {
                  x: 19,
                  y: 0,
                },
                zIndex: 1000,
                src:
                  that.markerList[0].icon || `${baseImgHost}/ditu/icon/jingdian/b.shan.png`,
              }),
            },
            zIndex: 1000,
            geometries: markerGeometries,
          });

          // marker点击事件
          that.markerggregate.on("click", function (evt, i) {
            // console.log(evt.geometry.position,1213123)
            if (that.map.getZoom() < (that.contentData.mapZoom || 18)) {
              that.map.setZoom(that.contentData.mapZoom || 18);
            }
            that.map.easeTo(
              { center: evt.geometry.position },
              { duration: 450 }
            );

            // 信息框切换必须要清空count该标识
            that.count = 0;
            that.isInfoClose = false;
            // 打开信息窗
            that.infoWindowMap.open(); // 打开信息窗
            // 更新位置
            that.infoWindowMap.setPosition(evt.geometry.position); // 设置信息窗位置
            // 设置信息窗内容
            that.infoWindowMap.setContent(templateContent2);
            that.markerList.forEach((v, i) => {
              // console.log(Number(v.coordinate.split(",")[0]),Number(v.coordinate.split(",")[1]),evt.geometry.position.lat,evt.geometry.position.lng)
              //根据当前点击marker的经纬度判断 是否在当前的数组中存在然后在设置信息框内容
              if (
                Number(v.coordinate.split(",")[0]) ==
                  evt.geometry.position.lng.toFixed(6) &&
                Number(v.coordinate.split(",")[1]) == evt.geometry.position.lat
              ) {
                if (v.link_spot) {
                  that.infoWindowMap.setContent(templateContent);
                } else {
                  that.infoWindowMap.setContent(templateContent2);
                }
              }
            });

            let lat = evt.geometry.position.lat;
            let lng = evt.geometry.position.lng;
            let windowInfoIndex = null;
            let infoImg = document.getElementById("infoImg");
            let detail = document.getElementById("detail");
            let windowInfoTitle = document.getElementById("windowInfoTitle");
            let tourInfo = document.getElementById("tour");
            $(detail).append("<a>123465</a>")
            let info = document.getElementById("info");
            let audioInfo = document.getElementById("audioInfo");
            let audioImg = document.getElementById("audioImg");

            that.changeInfoWindowDomText(that.markerList, lat, lng);

            that.changeWindowDomText(that.isEnglish);
            let tourDaolanMap = document.getElementById("tourDaolan")


            //景点点击弹出的模态框直接跳转地图
             var ua = navigator.userAgent.toLowerCase();


          let eword=that.choseMarker.name

            //  alert(123456798);

            if(tourDaolanMap){
              tourDaolanMap.onclick=()=>{
                // console.log(that.choseMarker)
                 let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${that.spointx}&spointy=${that.spointy}&epointx=${lat}&epointy=${lng}&eword=${eword?eword:""}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;

                 if (ua.match(/MicroMessenger/i) != "micromessenger") {
                    window.open(herf)
                 }else{
                  // alert("我要走微信的打开地图")
                   that.$wx.openLocation({
                      latitude: parseFloat(that.choseMarker.coordinate.split(",")[1]),
                      longitude: parseFloat(that.choseMarker.coordinate.split(",")[0]),
                      scale: 18,
                      success: function (res) {
                        // alert(JSON.stringify(res))
                      },
                      fail: function (err) {
                        // alert(JSON.stringify(err))
                      },
                    });
                 }
              }
            }
             if(location){
              location.onclick=()=>{
                // alert("123456978")

                 let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${that.spointx}&spointy=${that.spointy}&epointx=${lat}&epointy=${lng}&eword=${eword?eword:""}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;

                if (ua.match(/MicroMessenger/i) != "micromessenger") {
                  // alert("走h5")
                    window.open(herf)
                 }else{
                  that.$wx.openLocation({
                      latitude: parseFloat(that.choseMarker.coordinate.split(",")[1]),
                      longitude: parseFloat(that.choseMarker.coordinate.split(",")[0]),
                      scale: 18,
                      success: function (res) {
                        // alert(JSON.stringify(res))
                      },
                      fail: function (err) {
                        // alert(JSON.stringify(err))
                      },
                    });
                 }
              }
            }

            // 跳转景区
            if (tourInfo) {
              tourInfo.onclick = () => {
                // console.log(that.choseMarker.link_spot)
                window.open(that.choseMarker.link_spot);
              };
            }

            // 展示详情窗口
            info.onclick = () => {
              console.log(123465)
              let lat = evt.geometry.position.lat;
              let lng = evt.geometry.position.lng;
              that.infoWindowEvent(that.markerList, lat, lng);
            };

            // 播放音乐
            audioInfo.onclick = () => {
              // 播放
              that.$emit("audioOpen",true)
              console.log(123456789)
              if (that.count % 2 === 0) {
                // 已开启自动播放
                if (that.$parent.isOpenAudio) {
                  eventBus.emit(
                    "showMessage",
                    `${
                      that.isEnglish
                        ? messageEnglishMap[0].english
                        : messageEnglishMap[0].chinese
                    }`
                  );
                  return;
                }
                // 如果信息框切换并且有播放的那个id,说明上个歌曲还在播放状态,需要在下次播放前恢复上次的marker
                if (that.count === 0) {
                  //如果还有上次播放的,那么需要回复这个marker
                  if (that.removeId) {
                    that.addMarkerCluster(that.markerList[that.removeIndex]);
                  }
                  that.closeSrc(true);
                }

                let lat = evt.geometry.position.lat;
                let lng = evt.geometry.position.lng;

                that.markerList.forEach((item, index) => {
                  let obj = new TMap.LatLng(
                    item.coordinate.split(",")[1],
                    item.coordinate.split(",")[0]
                  );

                  if (
                    lat === obj.lat &&
                    Number(lng.toFixed(6)) === Number(obj.lng.toFixed(6))
                  ) {
                    that.removeId = item.id;
                    that.removeIndex = index;
                  }
                });
                // 需要支付
                if (
                  !that.isBuy &&
                  Number(that.markerList[that.removeIndex].type) === 1
                ) {
                  that.showPrizeDialog(that.removeIndex);
                  that.removeId = null;
                  that.removeIndex = null;
                  return;
                }
                that.markerCluster.remove(that.removeId);
                audioImg.src = baseImgHost + "/ditu/dongxiap.gif";
                that.changeSrc(that.removeIndex);
                that.audioMarker.setVisible(true);
                let arr = JSON.parse(JSON.stringify(that.markerList));
                let zoom = that.map.getZoom();
                let num = Number(
                  arr[that.removeIndex].coordinate.split(",")[0]
                );
                arr[that.removeIndex].coordinate =
                  num +
                  "," +
                  Number(arr[that.removeIndex].coordinate.split(",")[1]);
                that.updateAudioMarker(arr[that.removeIndex]);
              }
              // 暂停
              else {
                that.addMarkerCluster(that.markerList[that.removeIndex]);

                audioImg.src = baseImgHost + "/ditu/zanting.png";

                that.removeId = "";
                that.removeIndex = "";
                that.audioMarker.setVisible(false);
                that.closeSrc();
              }
              that.count++;
            };
          });
        }
      });
    },
    infoWindowEvent(arr, lat, lng) {
      arr.forEach((item, index) => {
        let obj = new TMap.LatLng(
          item.coordinate.split(",")[1],
          item.coordinate.split(",")[0]
        );

        if (
          lat === obj.lat &&
          Number(lng.toFixed(6)) === Number(obj.lng.toFixed(6))
        ) {
          console.log(index)
          this.showInfoIndex = index;
        }
      });
      this.showInfo(this.showInfoIndex);
    },
    // 移除控件
    removeControl() {
      if (!this.map.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)) {
        // 如果map上不存在该控件则直接返回
        return;
      }
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
    },

    // 展示信息弹窗
    showInfo(index) {
      console.log(index,this.lineMaker)
      let data={}
      if(this.lineTourMarkerList.length>0){
          data = {
          spointx: this.mylat,
          spointy: this.mylng,
          epointx: this.lineMaker[index].coordinate.split(",")[1],
          epointy: this.lineMaker[index].coordinate.split(",")[0],
          eword: this.lineMaker[index].name,
          info: this.lineMaker[index],
        };
      }else{
        data = {
          spointx: this.mylat,
          spointy: this.mylng,
          epointx: this.markerList[index].coordinate.split(",")[1],
          epointy: this.markerList[index].coordinate.split(",")[0],
          eword: this.markerList[index].name,
          info: this.markerList[index],
        };
      }

      console.log(data)
      eventBus.emit("showInfo", data);
    },

    // 关闭音乐
    closeSrc(type) {
      eventBus.emit("closeAudio", type);
    },

    // 切换音乐
    changeSrc(index) {
      eventBus.emit("changeAudioSrc", this.markerList[index]);
    },

    // 初始化路线图
    setLine(tlat = "", tlng = "") {
      let linePatharr = this.contentData.path_planning;
      let allPathArr = this.contentData.path_planning.map((item) => {
        return item.lineList.map((item) => {
          return new TMap.LatLng(item[0], item[1]);
        });
      });
      allPathArr.forEach((item, index) => {
        // console.log(item)
        this.initPolyline(item, index);
        this.initDashline(item, index);
        this.lnitLineMarker(item, index);
      });
      this.setLineVisibel();
    },

    initPolyline(item, index) {
      this.polylineArr[index] = new TMap.MultiPolyline({
        map: this.map,
        id: `polyline-layer${index}`,
        styles: {
          style: new TMap.PolylineStyle({
            color: "#ea5442", // 线填充色
            borderWidth: 1,
            width: 6, // 折线宽度
            borderColor: "#d12921", // 边线颜色
            lineCap: "square",
            showArrow: true, // 是否沿线方向展示箭头
            arrowOptions: {
              width: 8,
              height: 5,
              space: 80,
            },
            lineCap: "butt", // 线端头方式
          }),
        },
        geometries: [
          {
            // 第1条线
            id: "pl_1", // 折线唯一标识，删除时使用
            styleId: "style", // 绑定样式名
            paths: item,
          },
        ],
      });
    },
    initDashline(item, index) {
      this.dashPolylineArr[index] = new TMap.MultiPolyline({
        map: this.map,
        id: `polyline-layer-dash${index}`,
        styles: {
          style: new TMap.PolylineStyle({
            color: "#CCCCCC", // 线填充色
            borderWidth: 0,
            width: 1, // 折线宽度
            dashArray: [10, 10],
            borderColor: "#d12921", // 边线颜色
            lineCap: "butt", // 线端头方式
          }),
        },
        geometries: [
          {
            // 第1条线
            id: "pl_1", // 折线唯一标识，删除时使用
            styleId: "style", // 绑定样式名
            paths: item,
          },
        ],
      });
    },
    lnitLineMarker(item, index) {
      let obj = {};
// console.log(item,index)
      let startItem = item[0];

      let lastItem = item[item.length - 1];
      obj.startMarker = new TMap.MultiMarker({
        map: this.map,

        styles: {
          // 创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          myStyle: new TMap.MarkerStyle({
            width: 34, // 点标记样式宽度（像素）
            height: 34, // 点标记样式高度（像素）
            src: baseImgHost + "/ditu/startmarker.png", // 图片路径
            // 焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            anchor: { x: 10, y: 30 },
          }),
        },
        geometries: [
          {
            id: index, // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            styleId: `myStyle`, // 指定样式id
            position: startItem, // 点标记坐标位置
            properties: {
              // 自定义属性
              title: "marker1",
            },
          },
        ],
      });
      obj.endMarker = new TMap.MultiMarker({
        map: this.map,

        styles: {
          // 创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          myStyle: new TMap.MarkerStyle({
            width: 34, // 点标记样式宽度（像素）
            height: 34, // 点标记样式高度（像素）
            src: baseImgHost + "/ditu/endmarker.png", // 图片路径
            // 焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            anchor: { x: 10, y: 30 },
          }),
        },
        geometries: [
          {
            id: index, // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            styleId: `myStyle`, // 指定样式id
            position: lastItem, // 点标记坐标位置
            properties: {
              // 自定义属性
              title: "marker1",
            },
          },
        ],
      });
      this.lineMarkerList[index] = obj;
    },
    setLineVisibel(ind) {
      // console.log(ind)
      // console.log(ind)
      // console.log(this.contentData.path_planning)
      // this.markerList=this.contentData.path_planning[ind?ind:0].bitchIds
      // this.initMaskerCluster()
      // console.log(this.polylineArr,1)
      // console.log(this.dashPolylineArr,2)

      // console.log(this.lineMarkerList,3)

      this.polylineArr.forEach((item, index) => {
        if (index === ind) {
          item.setVisible(true);
        } else {
          item.setVisible(false);
        }
      });
      this.dashPolylineArr.forEach((item, index) => {
        if (index === ind) {
          item.setVisible(true);
        } else {
          item.setVisible(false);
        }
      });
      this.lineMarkerList.forEach((item, index) => {
        if (index === ind) {
          item.startMarker.setVisible(true);
          item.endMarker.setVisible(true);
        } else {
          item.startMarker.setVisible(false);
          item.endMarker.setVisible(false);
        }
      });
    },
    // 初始化背景图
    initImg() {
      // 新建一个ImageMapType，实现ImageMapTypeOptions规范

      if (!this.contentData.showBackImg) return;
      let boundaryArr = this.contentData.boundary;

      // 定义地图范围
      let sw = new TMap.LatLng(boundaryArr[1][0], boundaryArr[0][1]);
      let ne = new TMap.LatLng(boundaryArr[0][0], boundaryArr[1][1]);
      let minlongitude = boundaryArr[1][0];
      let minlatitude = boundaryArr[0][1];
      let maxlongitude = boundaryArr[0][0];
      let maxlatitude = boundaryArr[1][1];
      this.earthlayer = [];
      // console.log(minlongitude, minlatitude, maxlongitude, maxlatitude);
      // console.log(JSON.parse(localStorage.getItem("mapImgArr")))

      let map_imgsArr = localStorage.getItem("mapImgArr") ?JSON.parse(localStorage.getItem("mapImgArr")).reverse() :JSON.parse(this.contentData.map_imgs).reverse();
      // 1 2 0 1 2 0 1 2 0
      let arrlength = map_imgsArr.length;
      let that=this

      let sprtNum = Math.sqrt(arrlength);
      console.log(map_imgsArr)
      if(arrlength==0){
          that.$emit("changeLoading");
        }
      for (let i = 0; i < arrlength; i++) {
        // i = 0
        // 余数
        let num = (i + 1) % sprtNum;
        // 若为零取平方根
        if (num === 0) num = sprtNum;
        // 总共列数
        let column = arrlength / sprtNum;
        // 当前行数
        let row = (i + 1 - num) / sprtNum + 1;

        let sw = new TMap.LatLng(
          minlongitude + ((maxlongitude - minlongitude) / sprtNum) * (row - 1),
          maxlatitude - ((maxlatitude - minlatitude) / sprtNum) * num
        );
        let ne = new TMap.LatLng(
          minlongitude + ((maxlongitude - minlongitude) / sprtNum) * row,
          maxlatitude - ((maxlatitude - minlatitude) / sprtNum) * (num - 1)
        );
        let boundary = new TMap.LatLngBounds(sw, ne);

        this.earthlayer.push(
          new TMap.ImageGroundLayer({
            map: this.map,
            visible: true,
            zIndex: 1000000,
            src: `${prodImg + map_imgsArr[i]}`,
            bounds: boundary,
            minZoom: 1,
            maxZoom: 21,
          })
        );
        console.log(arrlength)

        if(i>=arrlength-1){
           setTimeout(()=>{
             that.$emit("changeLoading");
           },2000)
          // console.log(1230000000000000)
           document.onreadystatechange = function () {
          //that.$emit("changeLoading");
            console.log(document.readyState)
            if (document.readyState == "complete") {
              that.$emit("changeLoading");
              // 页面加载完毕

            }else{
              that.$emit("changeLoading");
            }
          };

        }
      }

    },
  },
   
};
</script>
<style lang="scss" scoped>
#mapTop {
  width: 100%;

  display: block;
  border-bottom: 1px solid rgb(182, 182, 182);
  position: relative;
  z-index: 1;
}
/deep/ p{
  overflow:hidden !important;

text-overflow:ellipsis !important;

display:-webkit-box;

-webkit-box-orient:vertical !important;

-webkit-line-clamp:2 !important;
}
.clusterBubble {
  border-radius: 50%;
  color: #fff;
  font-weight: 500;
  text-align: center;
  opacity: 0.88;
  background-image: linear-gradient(139deg, #4294ff 0%, #295bff 100%);
  // background: url('https://www1.xiaoniren.cn/saasapi/image/audios.png') no-repeat center center;
  // background-size: 100% 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0px;
  left: 0px;
}
.button-list {
  width: 100px;
  height: 30px;
  display: flex;
  justify-content: space-between;
}
.none {
  display: none;
}
.info-window {
  width: 200px;
  height: 120px;
}

</style>



// WEBPACK FOOTER //
// src/components/map.vue